import React from 'react';
import Brand from './Brand';
import HeaderNav from './HeaderNav';
import { LEGAL_VERSION, Terms, Disclaimer } from '../legal/2026-10-29-v2';

const LegalPage = ({ kind, user, onLogout, onOpenProfile }) => (
  <div className="app-shell">
    <header className="topbar">
      <Brand href="/" />
      <HeaderNav user={user} publicMode={!user} onLogout={onLogout} onOpenProfile={onOpenProfile} />
    </header>
    <main className="workspace legal-workspace">
      <article className="panel legal-document">
        <p className="eyebrow">Legal</p>
        <h1>{kind === 'terms' ? 'Terms and Conditions' : 'Disclaimer'}</h1>
        <p className="muted">Version {LEGAL_VERSION}</p>
        {kind === 'terms' ? <Terms /> : <Disclaimer />}
      </article>
    </main>
  </div>
);

export default LegalPage;
